/* src/modules/discounts/cards/DiscountsCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Paper,
} from '@material-ui/core';

import { Add } from '@material-ui/icons';

import { HeaderTable, PaperHeader } from '../../../../app/components';
import AddDiscountCard from '../AddDiscountCard';

import styles from './styles';

import { fetchDiscountHolders, fetchSeasons, selectDiscountHolder } from '../../actions';
import { getDiscountHolders } from '../../selectors';
import { loadTexts } from '../../../../config/texts';
const TEXT_KEY = 'discount';

class DiscountsCard extends React.Component {
  state = {
    // holder: null,
    texts: loadTexts(TEXT_KEY, this.props.locale),
    openAdd: false,
  };

  componentDidMount() {
    this._onFetchDiscountHolders({});
    this._onFetchSeasons({});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedUniversity !== this.props.selectedUniversity
      || nextProps.selectedOrganization !== this.props.selectedOrganization) {
      this._onFetchDiscountHolders({
        organizations: [nextProps.selectedOrganization],
        universities: [nextProps.selectedUniversity],
      });
      this._onFetchSeasons({ organizations: [nextProps.selectedOrganization] });
    }
  }

  _onFetchDiscountHolders = ({
    organizations = [this.props.selectedOrganization],
    universities = [this.props.selectedUniversity],
  }) => this.props.fetchDiscountHolders({ discountHolderSearchInput: {
    _organizations: organizations,
    _universities: universities,
  } });

  _onFetchSeasons = ({
    organizations = [this.props.selectedOrganization],
  }) => this.props.fetchSeasons({ seasonSearchInput: {
    _organizations: organizations,
  } });

  _onOpenAdd = () => {
    this.setState({ openAdd: true });
  }

  _onCloseAdd = () => {
    this.setState({ openAdd: false });
  }

  _onSelectOwner = ({ _id }) => {
    this.props.selectDiscountHolder(_id);
  }

  render() {
    const { openAdd, texts } = this.state;
    const { classes } = this.props;

    return (
      <Paper className={classes.paper}>
        <PaperHeader text={texts.title}>
          <Button color="primary" variant="fab" mini onClick={this._onOpenAdd}>
            <Add />
          </Button>
        </PaperHeader>
        <HeaderTable
          label={texts.title}
          data={this.props.discountHolders}
          hover
          onRowClick={this._onSelectOwner}
        />
        <AddDiscountCard
          open={openAdd}
          onClose={this._onCloseAdd}
          fetchOwners={this._onFetchDiscountHolders}
        />
      </Paper>
    );
  }
}

DiscountsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  fetchDiscountHolders: PropTypes.func.isRequired,
  fetchSeasons: PropTypes.func.isRequired,
  discountHolders: PropTypes.array.isRequired,
  selectedOrganization: PropTypes.string.isRequired,
  selectedUniversity: PropTypes.string.isRequired,
  selectDiscountHolder: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  discountHolders: getDiscountHolders(state),
  selectedOrganization: state.auth.selectedOrganization,
  selectedUniversity: state.auth.selectedUniversity,
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchDiscountHolders: params => dispatch(fetchDiscountHolders(params)()),
  fetchSeasons: params => dispatch(fetchSeasons(params)()),
  selectDiscountHolder: params => dispatch(selectDiscountHolder(params)),
});

export default compose(
  withStyles(styles, { name: 'DiscountsCard' }),
  connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })
)(DiscountsCard);



// WEBPACK FOOTER //
// ./src/modules/discounts/cards/DiscountsCard/index.js